import { GET_ADDRESS_DROPDOWN_LIST, SET_ADDRESS_DROPDOWN_LIST} from "./AddressSearchType";

const getAddressDropDownList = (state: any, target?: string) => ({
    type: GET_ADDRESS_DROPDOWN_LIST,
    state,
    target
});

const setAddressDropDownList = (addressDropDownList: any, target?: string) => ({
    type: SET_ADDRESS_DROPDOWN_LIST,
    addressDropDownList,
    target
});

export {
    getAddressDropDownList,
    setAddressDropDownList
}